// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".photo-page-pdf .pdf{height:200px;width:200px}", "",{"version":3,"sources":["webpack://./resources/js/views/pages/newsletter/single/Proof.vue"],"names":[],"mappings":"AAAA,qBAAA,YAAA,CAAA,WAAA","sourcesContent":[".photo-page-pdf .pdf{height:200px;width:200px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
